import { Dispatch, useState } from 'react';

export type UseTenant = [string, Dispatch<string>];

export const MAX_KELSEN_TENANT_NAME = 'Max Kelsen';

// default is max-kelsen
const useTenant = (): UseTenant => useState(MAX_KELSEN_TENANT_NAME);

export default useTenant;
